import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const n = t(
  (r, e) => /* @__PURE__ */ o.jsx(
    i,
    {
      ref: e,
      ...r,
      image: (s) => /* @__PURE__ */ o.jsx(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: 16,
          height: 16,
          fill: "none",
          viewBox: "0 0 16 16",
          ...s,
          children: /* @__PURE__ */ o.jsx(
            "path",
            {
              fill: "currentColor",
              d: "M15 1H1v2h14zM15 7H1v2h14zM1 13h14v2H1z"
            }
          )
        }
      )
    }
  )
);
n.displayName = "MenuIcon";
export {
  n as MenuIcon,
  n as default
};
//# sourceMappingURL=index.js.map
